import { CalendarMode, Row } from "PFApp/booking/types";
import { RowType } from "PFApp/booking/types/row";

import { calculateHoursBooked } from "../../helpers";
import { useBookingRowsContext } from "../context/booking_rows_context";
import { useBookingsOverviewContext } from "../context/bookings_overview_context";

type RowHoursBookedProps = {
  row: Row;
};

export const useRowHoursBooked = ({ row }: RowHoursBookedProps): string | null => {
  const { calendarMode } = useBookingsOverviewContext();
  const { bookingsByRowKey } = useBookingRowsContext();

  const { type, key } = row;
  const hoursBooked = calculateHoursBooked(bookingsByRowKey[key]);
  const shouldReturnValue =
    [RowType.Engagement, RowType.Role, RowType.Other].includes(type) &&
    calendarMode === CalendarMode.Workforce;

  return shouldReturnValue ? `${hoursBooked}h` : null;
};
